import React from 'react'
import styles from './description.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Description = ({
  classes,
  title,
  children,
  thanks,
  first,
  last,
  noBorder,
  smallFont
}) => (
  <div
    className={classNames(classes.container, {
      [classes.thanks]: thanks,
      [classes.first]: first,
      [classes.last]: last,
      [classes.noBorder]: noBorder,
      [classes.smallFont]: smallFont
    })}>
    <h3 className={classes.title}>{title}</h3>
    {children}
  </div>
)

export default injectSheet(styles)(Description)
